import * as SvelteImporter from '../src/svelteImporter.js'
import * as CustomSvelteImporter from '../src/host/svelteImporter.js'

SvelteImporter.createEventListeners('host', CustomSvelteImporter.customRequire)
